export enum TableType {
  InquiriesList = 'InquiriesList',
  Automations = 'Automations',
  InquiriesInbox = 'InquiriesInbox',
  RentalsList = 'RentalsList',
  PushAllRentals = 'PushAllRentals',
  CustomCodesList = 'CustomCodesList',
  AutomationLogs = 'AutomationLogs',
  GuestsList = 'GuestsList',
  InvoiceRuleLog = 'InvoiceRuleLog',
  AdditionalGuests = 'AdditionalGuests',
  GuestNotesList = 'GuestNotesList',
  GuestInteractionsList = 'GuestInteractionsList',
  GuestFilesList = 'GuestFilesList',
  GuestEmailsList = 'GuestEmailsList',
  GuestBookingsList = 'GuestBookingsList',
  GuestOtherBookingsList = 'GuestOtherBookingsList',
  Invoices = 'Invoices',
  EmailOptions = 'EmailOptions',
  FileCabinet = 'FileCabinet',
  BillingHistory = 'BillingHistory',
  AIChargeHistory = 'AIChargeHistory',
  Agenda = 'Agenda',
  Hold = 'Hold',
  Templates = 'Templates',
  Tasks = 'Tasks',
  InvoiceTemplates = 'InvoiceTemplates',
  InvoiceRules = 'InvoiceRules',
  InvoiceAssociatedRules = 'InvoiceAssociatedRules',
  InvoiceRuleActivityLog = 'InvoiceRuleActivityLog',
  UserSettings = 'UserSettings',
  UpcomingArrivals = 'UpcomingArrivals',
  UpcomingDepartures = 'UpcomingDepartures',
  PastDueInvoices = 'PastDueInvoices',
  DataFeed = 'DataFeed',
  ChannelConnections = 'ChannelConnections',
  Expenses = 'Expenses',
  InquiryDetailsPayments = 'InquiryDetailsPayments',
  InquiryDetailsNotes = 'InquiryDetailsNotes',
  InquiryDetailsFlights = 'InquiryDetailsFlights',
  InquiryDetailsMessages = 'InquiryDetailsMessages',
  PaymentGateways = 'PaymentGateways',
  SlackChannelConfig = 'SlackChannelConfig',
  PaymentRules = 'PaymentRules',
  PaymentGatewayLog = 'PaymentGatewayLog',
  SharedContent = 'SharedContent',
  RentalRates = 'RentalRates',
  GroupRates = 'GroupRates',
  ChannelAdjustments = 'ChannelAdjustments',
  RentalRateMappings = 'RentalRateMappings',
  MessageFeed = 'MessageFeed',
  MonthlyOccupancyRateChart = 'MonthlyOccupancyRateChart',
  BookingMtdChart = 'BookingMtdChart',
  RevenueMtdChart = 'RevenueMtdChart',
  ActivityFeed = 'ActivityFeed',
  Websites = 'Websites',
  WebsitePages = 'WebsitePages',
  WebsiteRentals = 'WebsiteRentals',
  VRBORentals = 'VRBORentals',
  AutomataTriggers = 'AutomataTriggers',
  Stealths = 'Stealths',
  RuleConditions = 'RuleConditions',
  DiscountCodes = 'DiscountCodes',
  LosDiscounts = 'LosDiscounts',
  RentalDiscounts = 'RentalDiscounts',
  DiscountCodeActivities = 'DiscountCodeActivities',
  DiscountCodeLogs = 'DiscountCodeLogs',
  BookingFormulas = 'BookingFormulas',
  Integrations = 'Integrations',
  rentalSearch = 'rental-search',
  InquiriesInboxList = 'InquiriesInboxList',
  ExportedCalendars = 'ExportedCalendars',
  ImportedCalendars = 'ImportedCalendars',
  ConnectionActivities = 'ConnectionActivities',
  NoRentals = 'no-rentals',
  NoBookings = 'no-bookings',
  NoRates = 'no-rates',

  Commissions = 'Commissions',
  EmailConnection = 'EmailConnection',
  MappedRentals = 'MappedRentals',
  AirbnbReviews = 'AirbnbReviews',
  AirbnbNotifications = 'AirbnbNotifications',
  AirbnbOpportunities = 'AirbnbOpportunities',
  Reviews = 'Reviews',

  AIDocuments = 'AIDocuments',
  AIWebsites = 'AIWebsites',
  AIIgnoreBookings = 'AIIgnoreBookings',
  AIIgnoreGuests = 'AIIgnoreGuests',
  AIIgnoreGuestsRegexp = 'AIIgnoreGuestsRegexp',
  AIIgnoreRentals = 'AIIgnoreRentals',
}
